// @flow

export {
  createOutputInterceptor,
} from './factories';
export type {
  OutputInterceptorType,
} from './types';
